<template>
  <v-container>
    <v-card id="contact-details">
      <v-card-title> Στοιχεία Οχήματος </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          :valid="valid"
        >
        <v-row>
          <v-col cols=12 sm=4 md=3>
          <v-text-field
          label="Αριθμός Πλαισίου"
          v-model="vin"
          :rules="[(v) => !!v || 'Model is required']"
          prepend-icon="mdi-counter"
            >
          </v-text-field>
          </v-col>
            <v-col cols=12 sm=4 md=3>
          <v-text-field
            v-model="model"
            prepend-icon="mdi-truck"
            :rules="[(v) => !!v || 'Model is required']"
            label="Μοντέλο Φορτηγού"
            >
          </v-text-field>
          </v-col>
        </v-row>
          <v-row>
          <v-col cols=6>
        <v-text-field
          v-model="abs_serialnum"
          :rules="[(v) => !!v || 'Serial Num is required']"
          label="Σειριακός Αριθμός ABS"
          prepend-icon="mdi-badge-account"
          >
          </v-text-field>
          </v-col>
          </v-row>
          <v-row>
          <v-col cols=6>
          <v-select
            v-model="abs_manf"
            :items="['WABCO', 'KNORR']"
            prepend-icon="mdi-account"
            label="Κατασκευαστής ABS"
            >
          </v-select>
          </v-col>
          <v-col cols=6>
          <v-text-field
            v-model="abs_model"
            prepend-icon="mdi-account"
            label="Μοντέλο ABS"
            >
          </v-text-field>
          </v-col>
          <v-col>
            <v-btn
              color="primary"
              class="ml-2 white--text"
              @click="genSap">
              <v-icon dark>mdi-file-send</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              class="ml-2 white--text"
              @click="copyText">
              <v-icon dark>mdi-content-copy</v-icon>
            </v-btn>
          </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
      <v-speed-dial
      v-model="fab"
      top
      right
      direction="left"
      absolute
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue darken-2"
          dark
          fab
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
            <v-btn
              fab
              color="primary"
              class="ml-2 white--text"
              @click="genSap">
              <v-icon dark>mdi-file-send</v-icon>
            </v-btn>
        </v-speed-dial>
      </v-card-actions>
    </v-card>

    <v-card class="mx-auto mt-10" id="item-list" >
      <v-card-title>Κείμενο Δήλωσης</v-card-title>
      <v-card-text>
        <v-textarea
          v-model="sapText"
          label="Κείμενο"
          >
        </v-textarea>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

export default {
  computed: {
  },
  data () {
    return {
      fab: false,
      vin: null,
      abs_model: null,
      abs_serialnum: null,
      abs_manf: null,
      model: null,
      sapText: "",
      valid: false,
    }
  },
  async created () {
  },
  methods: {
    copyText() {
      navigator.clipboard.writeText(this.sapText);
    },
    async genSap() {

      if (this.$refs.form.validate()) {
      let response = await this.$api.post(
        "/sap/generate",
        {
          vin: this.vin,
          model: this.model,
          abs_manf: this.abs_manf,
          abs_model: this.abs_model,
          abs_serialnum: this.abs_serialnum
        },
        {
          'content-type': 'application/json'
      }
      );

        this.sapText = response.data;
      }
    }
  },
}
</script>

<style>
.row-odd {
  background-color: orange;
}
.row-even {
  background-color: "red";
}
</style>
